import styles from './styles.module.scss';
import Bronze from './assets/Bronze.png'
import Prata from './assets/Prata.png'
import Ouro from './assets/Ouro.png'
import trofeu from './assets/Troféu Fases.png'
import trofeuFinal from './assets/Troféu Final.png'

export const Parabens = ({goForwards,module }) => {
    
    const getImage = () => {
        if(module.sort<=3) {
            return Bronze
        } else if (module.sort<=6) {
            return Prata
        }
            else if (module.sort<=9) {
                return Ouro;
            
        } else if (module.sort<=10) {
            return trofeu
        } else {
            return trofeuFinal
        }
    }

        
    const getParabens = () => {
        
       if (module.sort<=11) {
            return "Parabéns!"
        } else {
            return "Parabéns! Você concluiu todos os módulos"
        }
    }


    return (
        <div className={styles.wrapper}>
            <img src={getImage()} className={styles.imagem} />
            <p style={{fontWeight:900}}>{getParabens()}</p>
            <p>Você concluiu o módulo <span style={{fontWeight:900}}>{module.name}</span> </p>
            <button style={{fontSize: "2vh", color: "white"}} onClick={goForwards} className={styles.button}>
                Próxima fase
            </button>
        </div>
    );
};
